import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";

import { CustomToastContent } from "../../../../examples/CustomToastContent/index";

// @mui material components
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component
import Select from "react-select";

import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";

// Shared Create Modal
import CreateTestRecordModal from "../CreateTestRecordModal/index";

// Import Thermal Stability Actions
import {
    getThermalStabilityTest,
    createThermalStabilityTest,
    editThermalStabilityTest,
    deleteThermalStabilityTest,
    getProductsListForDpp,
    getSubModulesByRoleId,
    uploadCsvForThermalStability,
} from "../../../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const styleForEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 500, lg: 800 }, // Wided for many fields
    height: "fit-content",
    maxHeight: "90%",
    boxShadow: 24,
    p: 0,
    pt: 2,
    overflow: "auto",
};

const deleteStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    boxShadow: 24,
    p: 2,
    pt: 3,
};

const passFailOptions = [
    { label: "Pass", value: 1 },
    { label: "Fail", value: 0 },
];

const ThermalStabilityTest = ({
    getThermalStabilityTestReducer,
    getThermalStabilityTest,
    createThermalStabilityTest,
    editThermalStabilityTest,
    deleteThermalStabilityTest,
    dppIdSelectedForGlobalFilter,
    dropdownUI,
    getProductsListForDpp,
    getProductsListForDppReducer,
    getSubModulesByRoleId,
    getSubModulesByRoleIdReducer,
    uploadCsvForThermalStability,
}) => {
    let loginDetails = cookies.get("loginDetailsForWMS");
    let jwtToken = loginDetails?.jwt;
    let userId = loginDetails?.data?.userId;
    let roleId = loginDetails.data.roleId;

    useEffect(() => {
        getSubModulesByRoleId(roleId, jwtToken);
    }, [roleId]);

    const [modulesData, setModulesData] = useState([]);

    useEffect(() => {
        setModulesData(
            getSubModulesByRoleIdReducer.subModulesByRoleData.data
                ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
                : [],
        );
    }, [getSubModulesByRoleIdReducer]);

    let ItemLocationMapping = modulesData.find(
        (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
    );

    let allocateAccess = ItemLocationMapping?.actionId.includes("a5fde116-00b7-4ce0-939b-2482c5d161e1") || null;
    let viewAccess = ItemLocationMapping?.actionId.includes("896c7b19-7fe5-4306-9f06-2735e57a7b84") || null;
    let editAccess = ItemLocationMapping?.actionId.includes("9acd851e-2dc1-4bd1-a480-e7621d85ace8") || null;
    let deleteAccess = ItemLocationMapping?.actionId.includes("483ae968-cc38-4d30-ba63-887e9d32ba71") || null;

    const [loading, setLoading] = useState(true);
    const [dppOptions, setDPPOptions] = useState([]);
    const [openCreateModal, setOpenCreateModal] = useState(false);

    // Fetch Initial Data
    useEffect(() => {
        if (dppIdSelectedForGlobalFilter?.value) {
            getThermalStabilityTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
        } else {
            getThermalStabilityTest(null, jwtToken);
        }
    }, [dppIdSelectedForGlobalFilter, jwtToken]);

    useEffect(() => {
        getProductsListForDpp(jwtToken);
    }, [jwtToken]);

    useEffect(() => {
        let tempDppOptions = [];
        let dataList = getProductsListForDppReducer?.productsListForDpp?.data || [];
        dataList.forEach((item) => {
            tempDppOptions.push({ label: item.dppCode, value: item.dppId });
        });
        setDPPOptions(tempDppOptions);
    }, [getProductsListForDppReducer]);

    // DataTable State
    const [state, setState] = useState({
        columns: [
            { Header: "Test ID", accessor: "thermalStabilityId" },
            { Header: "DPP Code", accessor: "dppCode" },
            { Header: "Min Op. Temp", accessor: "minOperatingTemp" },
            { Header: "Max Op. Temp", accessor: "maxOperatingTemp" },
            { Header: "Test Temp", accessor: "thermalStabilityTestTemp" },
            { Header: "Duration", accessor: "thermalExposureDuration" },
            { Header: "Unit", accessor: "thermalExposureDurationUnit" },
            { Header: "Runaway Temp", accessor: "thermalRunawayOnsetTemp" },
            { Header: "Temp Rise", accessor: "temperatureRise" },
            { Header: "Result", accessor: "testResult" },
            { Header: "Remark", accessor: "remark" },
            {
                Header: "Action",
                accessor: "action",
                cannotSearch: true,
                cannotSort: true,
            },
        ],
        rows: [],
    });

    const { columns, rows } = state;


    const headers = [
        { label: "DPP Code", key: "dppCode" },
        { label: "Min Operating Temp", key: "minOperatingTemp" },
        { label: "Max Operating Temp", key: "maxOperatingTemp" },
        { label: "Stability Test Temp", key: "thermalStabilityTestTemp" },
        { label: "Exposure Duration", key: "thermalExposureDuration" },
        { label: "Duration Unit", key: "thermalExposureDurationUnit" },
        { label: "Runaway Onset Temp", key: "thermalRunawayOnsetTemp" },
        { label: "Temperature Rise", key: "temperatureRise" },
        { label: "Operating Temp Unit", key: "operatingTempUnit" },
        { label: "Test Result", key: "testResult" },
        { label: "Remark", key: "remark" }
    ];

    const headersForTemp = [
        { label: "dppCode", key: "dppCode" },
        { label: "minOperatingTemp", key: "minOperatingTemp" },
        { label: "maxOperatingTemp", key: "maxOperatingTemp" },
        { label: "thermalStabilityTestTemp", key: "thermalStabilityTestTemp" },
        { label: "thermalExposureDuration", key: "thermalExposureDuration" },
        { label: "thermalExposureDurationUnit", key: "thermalExposureDurationUnit" },
        { label: "thermalRunawayOnsetTemp", key: "thermalRunawayOnsetTemp" },
        { label: "temperatureRise", key: "temperatureRise" },
        { label: "operatingTempUnit", key: "operatingTempUnit" },
        { label: "testResult", key: "testResult" },
        { label: "remark", key: "remark" }
    ];

    const csvLink = {
        filename: "Thermal Stability Test List.csv",
        headers: headers,
        data: rows,
    };

    const csvLink2 = {
        filename: "Thermal Stability Upload Template.csv",
        headers: headersForTemp,
        data: [],
    };

    const [showUploadPanel, setShowUploadPanel] = useState(false);
    const [uploadCsvData, setUploadCsvData] = useState(null);

    const handleUploadClick = () => {
        setShowUploadPanel(!showUploadPanel);
        setUploadCsvData(null);
    };

    const uploadCsvHandler = async () => {
        if (!uploadCsvData) {
            toast.error("Please select a CSV file first!");
            return;
        }

        let formData = new FormData();
        formData.append("file", uploadCsvData);

        try {
            let res = await uploadCsvForThermalStability(formData, jwtToken);

            if (res?.status === true || res?.data?.status === true) {
                setShowUploadPanel(false);
                setUploadCsvData(null);

                let filterId = dppIdSelectedForGlobalFilter?.value || null;
                getThermalStabilityTest(filterId, jwtToken);
            }

            showUploadNotification(res);
        } catch (error) {
            showUploadNotification(error);
        }
    };

    const showUploadNotification = (res) => {
        const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

        const isSuccess = payload.status === true;
        const msg = payload.msg;
        const description = payload.description;

        const counts = {
            success: payload.successCount,
            error: payload.errorCount,
            duplicate: payload.duplicateCount
        };

        const toastOptions = {
            position: "top-center",
            autoClose: 5000,
            closeOnClick: false,
            draggable: true,
        };

        if (isSuccess) {
            toast.success(
                <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
                toastOptions
            );
        } else {
            toast.error(
                <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
                toastOptions
            );
        }
    };




    useEffect(() => {
        let tempMappedActivity = [];
        let data = getThermalStabilityTestReducer?.thermalStabilityTest?.data || [];

        setLoading(getThermalStabilityTestReducer?.loading || false);

        data.map((item) => {
            const itemObject = {
                thermalStabilityId: item.thermalStabilityId,
                dppId: item.dppId,
                dppCode: item.dppCode,
                minOperatingTemp: item.minOperatingTemp,
                maxOperatingTemp: item.maxOperatingTemp,
                thermalStabilityTestTemp: item.thermalStabilityTestTemp,
                thermalExposureDuration: item.thermalExposureDuration,
                thermalExposureDurationUnit: item.thermalExposureDurationUnit,
                thermalRunawayOnsetTemp: item.thermalRunawayOnsetTemp,
                temperatureRise: item.temperatureRise,
                operatingTempUnit: item.operatingTempUnit,
                testResult: item.testResult,
                remark: item.remark,
                action: (
                    <>
                        {deleteAccess && (
                            <DeleteButton
                                tooltip="Delete"
                                variant="gradient"
                                color="error"
                                iconOnly
                                type="button"
                                style={{ marginRight: "5px" }}
                                onClick={() => handleOpenDeleteModal(item)}
                            >
                                <Icon>delete</Icon>
                            </DeleteButton>
                        )}
                        {editAccess && (
                            <EditButton
                                tooltip="Edit"
                                variant="gradient"
                                color="success"
                                iconOnly
                                type="button"
                                onClick={() => handleOpenUpdateModal(item)}
                                style={{ marginRight: "5px" }}
                            >
                                <Icon>edit_sharp</Icon>
                            </EditButton>
                        )}
                    </>
                ),
            };
            tempMappedActivity.push(itemObject);
        });

        setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
    }, [getThermalStabilityTestReducer]);

    // Helper for Result Dropdown
    const getPassFailOption = (val) => {
        if (val === "Passed" || val === "Pass" || val === 1 || String(val) === "1") return passFailOptions[0];
        if (val === "Failed" || val === "Fail" || val === 0 || String(val) === "0") return passFailOptions[1];
        return null;
    };

    // ================= EDIT LOGIC =================
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
    const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
    const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
    const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
    const [editButtonName, setEditButtonName] = useState("Update");

    const handleOpenUpdateModal = (data) => {
        setSingleDataForUpdate(data);
        setOpenUpdateModal(true);
    };

    const handleCloseUpdateModal = (event, reason) => {
        if (reason === "backdropClick")
            return;
        setOpenUpdateModal(false);
        formikForUpdate.resetForm();
    };

    useEffect(() => {
        if (isSuccessForUpdate) setTimeout(() => setIsSuccessForUpdate(false), 3000);
        if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
    }, [isSuccessForUpdate, isErrorForUpdate]);

    const initialValueForUpdate = {
        thermalStabilityId: singleDataForUpdate.thermalStabilityId || "",
        DPPID: singleDataForUpdate.dppCode || "",
        minOperatingTemp: singleDataForUpdate.minOperatingTemp || "",
        maxOperatingTemp: singleDataForUpdate.maxOperatingTemp || "",
        thermalStabilityTestTemp: singleDataForUpdate.thermalStabilityTestTemp || "",
        thermalExposureDuration: singleDataForUpdate.thermalExposureDuration || "",
        thermalExposureDurationUnit: singleDataForUpdate.thermalExposureDurationUnit || "Hours",
        thermalRunawayOnsetTemp: singleDataForUpdate.thermalRunawayOnsetTemp || "",
        temperatureRise: singleDataForUpdate.temperatureRise || "",
        operatingTempUnit: singleDataForUpdate.operatingTempUnit || "C",
        testResult: getPassFailOption(singleDataForUpdate.testResult),
        remark: singleDataForUpdate.remark || "",
    };

    const validationSchemaForUpdate = Yup.object({
        minOperatingTemp: Yup.number().typeError("Must be a number").required("Required"),
        maxOperatingTemp: Yup.number().typeError("Must be a number").required("Required"),
        thermalStabilityTestTemp: Yup.number().typeError("Must be a number").required("Required"),
        thermalExposureDuration: Yup.number().typeError("Must be a number").required("Required"),
        thermalExposureDurationUnit: Yup.string().required("Required"),
        thermalRunawayOnsetTemp: Yup.number().typeError("Must be a number").required("Required"),
        temperatureRise: Yup.number().typeError("Must be a number").required("Required"),
        operatingTempUnit: Yup.string().required("Required"),
        testResult: Yup.object().nullable().required("Required"),
        remark: Yup.string().required("Required"),
    });

    const onSubmitForUpdate = async (values) => {
        setEditButtonName("Please wait...");
        const payload = {
            thermalStabilityId: values.thermalStabilityId,
            dppId: singleDataForUpdate.dppId,
            minOperatingTemp: String(values.minOperatingTemp),
            maxOperatingTemp: String(values.maxOperatingTemp),
            thermalStabilityTestTemp: String(values.thermalStabilityTestTemp),
            thermalExposureDuration: String(values.thermalExposureDuration),
            thermalExposureDurationUnit: values.thermalExposureDurationUnit,
            thermalRunawayOnsetTemp: String(values.thermalRunawayOnsetTemp),
            temperatureRise: String(values.temperatureRise),
            operatingTempUnit: values.operatingTempUnit,
            testResult: values.testResult?.value,
            remark: values.remark,
            userId: userId || "system",
        };

        let res = await editThermalStabilityTest(payload, jwtToken);

        if (res.status) {
            setIsSuccessForUpdate(true);
            getThermalStabilityTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
            setTimeout(() => {
                handleCloseUpdateModal();
                setEditButtonName("Update");
            }, 2000);
        } else {
            setIsErrorForUpdate(true);
            setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
            setEditButtonName("Update");
        }
    };

    const formikForUpdate = useFormik({
        initialValues: initialValueForUpdate,
        validationSchema: validationSchemaForUpdate,
        onSubmit: onSubmitForUpdate,
        enableReinitialize: true,
    });

    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [singleDataForDelete, setSingleDataForDelete] = useState({});
    const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
    const [isErrorForDelete, setIsErrorForDelete] = useState(false);
    const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
    const [deleteButtonName, setDeleteButtonName] = useState("Delete");

    const handleOpenDeleteModal = (data) => {
        setSingleDataForDelete(data);
        setOpenDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    useEffect(() => {
        if (isSuccessForDelete) setTimeout(() => setIsSuccessForDelete(false), 2000);
        if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
    }, [isSuccessForDelete, isErrorForDelete]);

    const deleteRecord = async () => {
        setDeleteButtonName("Please wait...");
        let testId = singleDataForDelete.thermalStabilityTestId;
        let udBy = userId || "system";

        let res = await deleteThermalStabilityTest(testId, udBy, jwtToken);

        if (res.status) {
            setIsSuccessForDelete(true);
            getThermalStabilityTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
            setTimeout(() => {
                handleCloseDeleteModal();
                setDeleteButtonName("Delete");
            }, 2000);
        } else {
            setIsErrorForDelete(true);
            setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
            setDeleteButtonName("Delete");
        }
    };

    return (
        <div>
            <MDBox pt={0} pb={0} mb={-2.5}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <MDBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            p={0}
                            mb={-4.5}
                            mt={-1}
                        >
                            <MDBox color="text" px={2} ml={-2} mb={4} display="flex" alignItems="center">
                                {allocateAccess && (
                                    <MDBox display="flex" alignItems="center">

                                        <Tooltip >
                                            <CreateButton tooltip="Add Thermal Stability Test" onClick={() => setOpenCreateModal(true)}>
                                                <Icon>add</Icon>
                                            </CreateButton>
                                        </Tooltip>

                                        <CSVLink {...csvLink}>
                                            <DownloadDataButton
                                                tooltip="Download Thermal Stability Test List"
                                                style={{ marginLeft: "1rem" }}
                                                type="button"
                                                variant="outlined"
                                                color="error"
                                                iconOnly
                                            >
                                                <Icon>download</Icon>
                                            </DownloadDataButton>
                                        </CSVLink>



                                        <UploadButton
                                            tooltip="Upload CSV"
                                            style={{ marginLeft: "1rem", marginTop: "3px" }}
                                            type="button"
                                            variant={showUploadPanel ? "contained" : "outlined"}
                                            color="info"
                                            iconOnly
                                            onClick={handleUploadClick}
                                        >
                                            <Icon>upload</Icon>
                                        </UploadButton>

                                        <CSVLink {...csvLink2}>
                                            <DownloadButton
                                                tooltip="Download Template"
                                                style={{ marginLeft: "1rem" }}
                                                type="button"
                                                variant="outlined"
                                                color="error"
                                                iconOnly
                                            >
                                                <Icon>description</Icon>
                                            </DownloadButton>
                                        </CSVLink>

                                        {showUploadPanel && (
                                            <MDBox
                                                display="flex"
                                                alignItems="center"
                                                ml={2}
                                                p={0.5}
                                                px={2}
                                            >
                                                <input
                                                    className="choose_file"
                                                    type="file"
                                                    accept=".csv"
                                                    onChange={(e) => setUploadCsvData(e.target.files[0])}
                                                    style={{ width: "200px" }}
                                                />

                                                <MDButton
                                                    disabled={!uploadCsvData?.name || uploadCsvData?.type !== "text/csv"}
                                                    variant="contained"
                                                    color="info"
                                                    style={{ marginLeft: "1rem" }}
                                                    onClick={uploadCsvHandler}
                                                >
                                                    UPLOAD
                                                </MDButton>

                                                <IconButton
                                                    size="small"
                                                    onClick={() => setShowUploadPanel(false)}
                                                    style={{ marginLeft: "10px", color: "gray" }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </MDBox>
                                        )}

                                    </MDBox>
                                )}
                            </MDBox>

                            <MDBox mb={4} mr={1}>
                                {dropdownUI}
                            </MDBox>
                        </MDBox>

                        {/* DataTable */}
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns, rows }}
                                isSorted={true}
                                tableSearch={true}
                                entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20, 25] }}
                                showTotalEntries={true}
                                noEndBorder
                            />
                        </MDBox>

                        {/* CREATE MODAL CALLED HERE */}
                        <CreateTestRecordModal
                            open={openCreateModal}
                            handleClose={() => setOpenCreateModal(false)}
                            jwtToken={jwtToken}
                            userId={userId}
                            dppOptions={dppOptions}
                            onSuccessRefresh={() => { }}
                        />

                        {/* UPDATE MODAL */}
                        <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
                            <MDCard sx={styleForEdit}>
                                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                                        Update Thermal Stability Test
                                    </MDTypography>
                                    <Tooltip title="Close">
                                        <IconButton
                                            style={{
                                                background: "whitesmoke", color: "black", borderRadius: 5, marginRight: "10px",
                                                marginTop: "4px",
                                            }}
                                            onClick={handleCloseUpdateModal}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </Tooltip>
                                </MDBox>
                                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                                <MDBox pt={1} pb={3} px={3}>
                                    <MDBox component="form" role="form" onSubmit={formikForUpdate.handleSubmit}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">DPP Code</MDTypography>
                                                    <MDInput size="small" type="text" fullWidth disabled={true} value={formikForUpdate.values.DPPID} />
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Min Operating Temp</MDTypography>
                                                    <MDInput size="small" type="number" name="minOperatingTemp" fullWidth autoComplete="off" value={formikForUpdate.values.minOperatingTemp} onChange={formikForUpdate.handleChange} onBlur={formikForUpdate.handleBlur} error={formikForUpdate.touched.minOperatingTemp && Boolean(formikForUpdate.errors.minOperatingTemp)} />
                                                    {formikForUpdate.touched.minOperatingTemp && formikForUpdate.errors.minOperatingTemp && <TextError msg={formikForUpdate.errors.minOperatingTemp} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Max Operating Temp</MDTypography>
                                                    <MDInput size="small" type="number" name="maxOperatingTemp" fullWidth autoComplete="off" value={formikForUpdate.values.maxOperatingTemp} onChange={formikForUpdate.handleChange} onBlur={formikForUpdate.handleBlur} error={formikForUpdate.touched.maxOperatingTemp && Boolean(formikForUpdate.errors.maxOperatingTemp)} />
                                                    {formikForUpdate.touched.maxOperatingTemp && formikForUpdate.errors.maxOperatingTemp && <TextError msg={formikForUpdate.errors.maxOperatingTemp} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Stability Test Temp</MDTypography>
                                                    <MDInput size="small" type="number" name="thermalStabilityTestTemp" fullWidth autoComplete="off" value={formikForUpdate.values.thermalStabilityTestTemp} onChange={formikForUpdate.handleChange} onBlur={formikForUpdate.handleBlur} error={formikForUpdate.touched.thermalStabilityTestTemp && Boolean(formikForUpdate.errors.thermalStabilityTestTemp)} />
                                                    {formikForUpdate.touched.thermalStabilityTestTemp && formikForUpdate.errors.thermalStabilityTestTemp && <TextError msg={formikForUpdate.errors.thermalStabilityTestTemp} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Exposure Duration</MDTypography>
                                                    <MDInput size="small" type="number" name="thermalExposureDuration" fullWidth autoComplete="off" value={formikForUpdate.values.thermalExposureDuration} onChange={formikForUpdate.handleChange} onBlur={formikForUpdate.handleBlur} error={formikForUpdate.touched.thermalExposureDuration && Boolean(formikForUpdate.errors.thermalExposureDuration)} />
                                                    {formikForUpdate.touched.thermalExposureDuration && formikForUpdate.errors.thermalExposureDuration && <TextError msg={formikForUpdate.errors.thermalExposureDuration} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Duration Unit</MDTypography>
                                                    <MDInput size="small" type="text" name="thermalExposureDurationUnit" fullWidth value={formikForUpdate.values.thermalExposureDurationUnit} onChange={formikForUpdate.handleChange} />
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Runaway Onset Temp</MDTypography>
                                                    <MDInput size="small" type="number" name="thermalRunawayOnsetTemp" fullWidth autoComplete="off" value={formikForUpdate.values.thermalRunawayOnsetTemp} onChange={formikForUpdate.handleChange} onBlur={formikForUpdate.handleBlur} error={formikForUpdate.touched.thermalRunawayOnsetTemp && Boolean(formikForUpdate.errors.thermalRunawayOnsetTemp)} />
                                                    {formikForUpdate.touched.thermalRunawayOnsetTemp && formikForUpdate.errors.thermalRunawayOnsetTemp && <TextError msg={formikForUpdate.errors.thermalRunawayOnsetTemp} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Temperature Rise</MDTypography>
                                                    <MDInput size="small" type="number" name="temperatureRise" fullWidth autoComplete="off" value={formikForUpdate.values.temperatureRise} onChange={formikForUpdate.handleChange} onBlur={formikForUpdate.handleBlur} error={formikForUpdate.touched.temperatureRise && Boolean(formikForUpdate.errors.temperatureRise)} />
                                                    {formikForUpdate.touched.temperatureRise && formikForUpdate.errors.temperatureRise && <TextError msg={formikForUpdate.errors.temperatureRise} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Op. Temp Unit</MDTypography>
                                                    <MDInput size="small" type="text" name="operatingTempUnit" fullWidth value={formikForUpdate.values.operatingTempUnit} onChange={formikForUpdate.handleChange} />
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Test Result</MDTypography>
                                                    <Select isClearable className="select-css" placeholder="Pass/Fail..." name="testResult" value={formikForUpdate.values.testResult} options={passFailOptions} onChange={(opt) => formikForUpdate.setFieldValue("testResult", opt)} onBlur={() => formikForUpdate.setFieldTouched("testResult", true)} menuPortalTarget={document.body} styles={{ menuPortal: (b) => ({ ...b, zIndex: 9999 }) }} />
                                                    {formikForUpdate.touched.testResult && formikForUpdate.errors.testResult && <TextError msg={formikForUpdate.errors.testResult} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={8}>
                                                <MDBox mb={1} ml={1}>
                                                    <MDTypography variant="h6">Remark</MDTypography>
                                                    <MDInput size="small" type="text" name="remark" fullWidth autoComplete="off" value={formikForUpdate.values.remark} onChange={formikForUpdate.handleChange} onBlur={formikForUpdate.handleBlur} error={formikForUpdate.touched.remark && Boolean(formikForUpdate.errors.remark)} />
                                                    {formikForUpdate.touched.remark && formikForUpdate.errors.remark && <TextError msg={formikForUpdate.errors.remark} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Collapse in={isErrorForUpdate}>
                                                    <Alert severity="error" action={<IconButton size="small" onClick={() => setIsErrorForUpdate(false)}><CloseIcon fontSize="inherit" /></IconButton>}>{errorMsgForUpdate}</Alert>
                                                </Collapse>
                                                <Collapse in={isSuccessForUpdate}>
                                                    <Alert severity="success" action={<IconButton size="small" onClick={() => setIsSuccessForUpdate(false)}><CloseIcon fontSize="inherit" /></IconButton>}>Updated successfully</Alert>
                                                </Collapse>
                                                <MDBox mt={2}>
                                                    <MDButton color="info" type="submit" fullWidth disabled={editButtonName === "Please wait..."}>{editButtonName}</MDButton>
                                                </MDBox>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                </MDBox>
                            </MDCard>
                        </Modal>

                        {/* DELETE MODAL */}
                        <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
                            <MDCard sx={deleteStyle}>
                                <MDTypography>Are you sure you want to delete?</MDTypography>
                                <MDBox mt={2} display="flex" justifyContent="space-between">
                                    <MDButton color="info" variant="outlined" onClick={handleCloseDeleteModal}>Cancel</MDButton>
                                    <MDButton color="error" onClick={deleteRecord} disabled={deleteButtonName === "Please wait..."}>{deleteButtonName}</MDButton>
                                </MDBox>
                                <MDBox mt={2}>
                                    <Collapse in={isErrorForDelete}><Alert severity="error" action={<IconButton size="small" onClick={() => setIsErrorForDelete(false)}><CloseIcon fontSize="inherit" /></IconButton>}>{errorMsgForDelete}</Alert></Collapse>
                                    <Collapse in={isSuccessForDelete}><Alert severity="success" action={<IconButton size="small" onClick={() => setIsSuccessForDelete(false)}><CloseIcon fontSize="inherit" /></IconButton>}>Deleted Successfully</Alert></Collapse>
                                </MDBox>
                            </MDCard>
                        </Modal>

                    </Grid>
                </Grid>
            </MDBox>

            {loading && (
                <Backdrop sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <ToastContainer />
        </div>
    );
};

const mapStateToProps = (state) => ({
    getThermalStabilityTestReducer: state.getThermalStabilityTestReducer,
    getProductsListForDppReducer: state.getProductsListForDppReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
    getSubModulesByRoleId: (roleId, jwtToken) => dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getThermalStabilityTest: (dppId, jwtToken) => dispatch(getThermalStabilityTest(dppId, jwtToken)),
    createThermalStabilityTest: (payload, jwtToken) => dispatch(createThermalStabilityTest(payload, jwtToken)),
    editThermalStabilityTest: (payload, jwtToken) => dispatch(editThermalStabilityTest(payload, jwtToken)),
    deleteThermalStabilityTest: (testId, jwtToken) => dispatch(deleteThermalStabilityTest(testId, jwtToken)),
    getProductsListForDpp: (jwtToken) => dispatch(getProductsListForDpp(jwtToken)),
    uploadCsvForThermalStability: (formData, jwtToken) => dispatch(uploadCsvForThermalStability(formData, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThermalStabilityTest);